export enum EnvironmentType {
  PRODUCTION = "production",
  BLUE = "blue",
  HML = "hml",
  LOCAL = "local",
}

export const CONFIG = "CONFIG";
